module.exports = __webpack_public_path__ + "img/drt1.78deff32.png";